import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IButton } from '@core/modules/components/button-v2/button.interface';
import {
  buttonConditions,
  headerConditions,
  itemsConditions,
} from '@shared/conditions-v2/conditions.db';
import { ConditionsV2Imports } from '@shared/conditions-v2/conditions.imports';
import { ISection } from '@shared/interfaces/section.interface';

@Component({
  selector: 'noda-conditions-v2',
  standalone: true,
  templateUrl: './conditions.component.html',
  styleUrls: ['./conditions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: ConditionsV2Imports,
})
export class ConditionsComponent {
  public buttonData: IButton = buttonConditions;
  public headerData: ISection = headerConditions;
  public itemsData: string[] = itemsConditions;
}
